/** 並び順・回転編集・詳細パネルの生存期間で共用する scope キー */
export function buildPlanningScopeKey(companyId: string, startOn: string, endOn: string): string {
  return `${companyId}:${startOn}:${endOn}`;
}

export function resolveSortedTruckIds(
  state: { rangeKey: string; ids: number[] },
  currentRangeKey: string,
): number[] {
  return state.rangeKey === currentRangeKey ? state.ids : [];
}
